<template>
  <div>
    <qrcode-stream @decode="onDecode($event)" @init="onInit($event)" />
    <p class="error">{{ error }}</p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      code: '',
      error: ''
    };
  },
  methods: {
    onDecode(result) {
      this.code = result;
      if (this.code) {
        this.$emit('qr-code', this.code)
      }
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = 'Error: Debe otorgar el permiso de acceso a la cámara';
        } else if (error.name === 'NotFoundError') {
          this.error = 'Error: No hay cámara en este dispositivo';
        } else if (error.name === 'NotSupportedError') {
          this.error = 'Error: Contexto seguro requerido (HTTPS, localhost)';
        } else if (error.name === 'NotReadableError') {
          this.error = 'Error: ¿La cámara ya está en uso?';
        } else if (error.name === 'OverconstrainedError') {
          this.error = 'Error: Las cámaras instaladas no son adecuadas';
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = 'Error: Stream API no es compatible con este navegador';
        } else if (error.name === 'TypeError') {
          this.error =
            'Error: Tu navegador no soporta esta opción, actualízalo ó cambia de navegador';
        } else {
          this.error = `Error desconocido: ${error.message}`;
        }
      }
    }
  }
};
</script>
